const muy_rock_and_roll = [
    {
        "tipoVenta": "ALTA_NUEVA",
        "tipoLinea": "LINEA_PRINCIPAL",
        "tarifa": {
            "id": "PPOSCONVERGENTAVATEL2",
            "price": 37.1818,
            "name": "Rock & Roll - 600 MB + 50GB",
            "operator": "AVATEL",
            "segment": "PARTICULAR",
            "category": "convergent",
            "color": "",
            "commercial_enrichment": "",
            "description_file": "",
            "fixed_line_info": {
                "type": "",
                "owners": [],
                "upload_speed": {
                    "unit": "Mb",
                    "amount": 0
                },
                "download_speed": {
                    "unit": "Mb",
                    "amount": 0
                },
                "voice_to_fixed": {
                    "unit": "min",
                    "amount": 0
                },
                "voice_to_mobile": {
                    "unit": "min",
                    "amount": 0
                }
            },
            "mobile_line_info": {
                "mobile_line_data": {
                    "unit": "GB",
                    "amount": 0
                },
                "mobile_line_voice": {
                    "unit": "min",
                    "amount": 0
                }
            },
            "payment_type": "postpaid",
            "is_active": true,
            "created_on": "2022-11-28T01:15:28.264136+01:00",
            "updated_on": "2022-11-28T01:26:52.156548+01:00",
            "svas": [
                "MAS_CLICTV_10AVATEL"
            ],
            "promotions": [
                "PROMOAVATEL",
                "PROMOAVATEL1"
            ],
            "additional_lines": []
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": [
            {
                "id": "PROMOAVATEL",
                "duration": 3,
                "name": "Sin Permanencia",
                "duration_unit": "month",
                "amount": "5.00",
                "amount_unit": "MONETARY",
                "is_active": true,
                "observations": null,
                "operator": "AVATEL"
            }
        ]
    },
    {
        "tipoVenta": "ALTA_NUEVA",
        "tipoLinea": "LINEA_ADICIONAL",
        "tarifa": {
            "id": "PCOMAVATEL",
            "price": 0,
            "max_number": 0,
            "mobile_line_info": {
                "price": {
                    "base_fee": "0.0000"
                },
                "mobile_line_data": {
                    "unit": "",
                    "amount": ""
                },
                "mobile_line_voice": {
                    "unit": "min",
                    "amount": ""
                }
            },
            "name": "Comparte",
            "operator": "AVATEL",
            "segment": "PARTICULAR",
            "is_active": true,
            "created_on": "2022-11-24T18:04:53.984964+01:00",
            "updated_on": "2022-11-24T18:04:53.985002+01:00",
            "promotions": []
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": []
    },
    {
        "tipoVenta": null,
        "tipoLinea": "LINEA_ADICIONAL_SVA",
        "tarifa": {
            "id": "MAS_CLICTV_10AVATEL",
            "price": 8.2645,
            "name": "Más CLICtv",
            "operator": "AVATEL",
            "image": "",
            "more_info": "",
            "permanence": 0,
            "segment": "PARTICULAR",
            "is_active": true,
            "created_on": "2022-11-24T17:53:14.479429+01:00",
            "updated_on": "2022-12-05T12:47:52.823685+01:00",
            "promotions": [
                "PROMOAVATEL2",
                "PROMOAVATEL6"
            ]
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": []
    }
]

export default muy_rock_and_roll;